
@if (preloader) {
  <div id="preloader" ></div>
}




@if (loginDisplay) {
  <div >
    @if (headerFooter) {
      <app-header></app-header>
    }
    <router-outlet></router-outlet>
    @if (headerFooter) {
      <app-footer></app-footer>
    }
  </div>
}



